// extracted by mini-css-extract-plugin
export default {"cell":"ShelfCell_cell__mHbHa","checked":"ShelfCell_checked__WZwLd","coords":"ShelfCell_coords__iQfk7"};